import { render, staticRenderFns } from "./PluginEditPanel.vue?vue&type=template&id=461db21a&scoped=true"
import script from "./PluginEditPanel.vue?vue&type=script&lang=ts"
export * from "./PluginEditPanel.vue?vue&type=script&lang=ts"
import style0 from "./PluginEditPanel.vue?vue&type=style&index=0&id=461db21a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461db21a",
  null
  
)

export default component.exports